import { render, staticRenderFns } from "./CustomerUpdatesAdd.vue?vue&type=template&id=339b35e1"
import script from "./CustomerUpdatesAdd.vue?vue&type=script&lang=js"
export * from "./CustomerUpdatesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports